import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllConsumibles() {
    console.log("Hola");
    const ConsumiblesDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Almacen_empaque/Consumibles/Productos/".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      ConsumiblesDB.push(doc.data());
    });
    return ConsumiblesDB;
    

}
